import _ from 'lodash'

import { router } from '_/router/router'

import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'

import { store } from '_/vuex/store'

const InputTextField = Vue.component(
  'InputTextField',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

export default {
  /**
   * Set the components
   *
   * @type  {Object}
   */
  components: {
    InputTextField,
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    ...mapGetters({
      generator: 'generator/generator',
      photonModule: 'photonModule/photonModule',
      subscription: 'subscription/subscription',
      ui: 'ui/ui',
    }),

    /**
     * Check if user can delete module
     *
     * @type {object}
     */
    isDeleteDisabled() {
      return !!this.generator.selectedModule.is_system
    },

    /**
     * Checkbox two-way binding model
     *
     * @type {object}
     */
    createShortcut: {
      get() {
        return this.generator.createShortcut
      },
      set(value) {
        return this.setCreateShortcut({ value })
      },
    },

    /**
     * Date format getter
     *
     * @return  {string}
     */
    dateFormat() {
      return this.ui.photonConfig.dateFormat
    },

    /**
     * Created at getter
     *
     * @return  {string}
     */
    createdAt() {
      return this.generator.selectedModule.created_at
        ? moment(this.generator.selectedModule.created_at).format(
            this.dateFormat
          )
        : null
    },

    /**
     * Updated at getter
     *
     * @return  {string}
     */
    updatedAt() {
      return this.generator.selectedModule.updated_at
        ? moment(this.generator.selectedModule.updated_at).format(
            this.dateFormat
          )
        : null
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    ...mapActions('generator', ['deleteModule', 'setCreateShortcut']),

    /**
     * Submit form
     *
     * @return  {void}
     */
    submitForm() {
      $('#generator-form').submit()
    },

    /**
     * Triggers the create mode
     *
     * @return  {void}
     */
    createNewModule() {
      router.push('/generator')
    },

    /**
     * Reroutes to module editing
     *
     * @param   {string}  tableName
     * @return  {void}
     */
    navigateToModule(tableName) {
      router.push(`/admin/${tableName}`)
    },

    /**
     * Confirms module deletion with browser dialog
     *
     * @return  {void}
     */
    confirmDeleteModule() {
      const moduleName = this.generator.selectedModule.name[store.state.ui.defaultLocale.languageCode]
      const confirmMessage = `Are you sure you want to delete the module "${moduleName}"? This action cannot be undone.`
      
      if (confirm(confirmMessage)) {
        this.deleteModule({ reporting: false }).then(() => {
          // Navigate back to generator after successful deletion
          router.push('/generator')
        })
      }
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(() => {
      // Use uniform to style checkbox/radio elements
      $(this.$el)
        .find('input[type="checkbox"]')
        .uniform()
    })
  },
}
